/**
 * sessionHandleStore.ts
 *
 * Stores FileSystemDirectoryHandle objects in IndexedDB so they can survive
 * a page navigation (e.g. Confirmation → UploadWizard "Add More This Session").
 *
 * FileSystemDirectoryHandle objects cannot be serialised to JSON / sessionStorage,
 * but IndexedDB can store them natively as structured-clone values.
 */

import { openDB } from "idb";

const DB_NAME = "footage-manager-handles";
const STORE_NAME = "handles";
const DB_VERSION = 1;

async function getDB() {
  return openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    },
  });
}

export async function saveHandle(key: string, handle: FileSystemDirectoryHandle): Promise<void> {
  const db = await getDB();
  await db.put(STORE_NAME, handle, key);
}

export async function loadHandle(key: string): Promise<FileSystemDirectoryHandle | undefined> {
  const db = await getDB();
  return db.get(STORE_NAME, key);
}

export async function deleteHandle(key: string): Promise<void> {
  const db = await getDB();
  await db.delete(STORE_NAME, key);
}
